var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCall = function SvgCall(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.804 20.519a3.05 3.05 0 0 1-3.797-.416L3.45 18.544a1.525 1.525 0 0 1 0-2.157l2.161-2.162a1.525 1.525 0 0 1 2.157 0l1.618 1.618a14.4 14.4 0 0 0 3.771-2.692 14.4 14.4 0 0 0 2.697-3.775l-1.618-1.618a1.525 1.525 0 0 1 0-2.158l2.157-2.157a1.525 1.525 0 0 1 2.158 0l1.558 1.559a3.05 3.05 0 0 1 .416 3.796 38.2 38.2 0 0 1-5.21 6.51 38.2 38.2 0 0 1-6.51 5.21",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCall);
export { ForwardRef as ReactComponent };